/*
 * function that will process the deepest array from paths
 * to properly add the 'passwordSource' field
 */
export const addPasswordSourceFieldToPath = (path) => {
  // if given path is undefined, empty, or not an array return an array with only one obj
  if (!path || !path.length || !Array.isArray(path)) {
    const attributes = { passwordSource: 'JumpCloud' };
    const to = { attributes };
    return [{ attributes, to }];
  }

  return path.map(childPath => {
    const attributes = {
      ...childPath.attributes,
      passwordSource: childPath.attributes?.passwordSource ?? 'JumpCloud',
    };
    const to = {
      ...childPath.to,
      attributes,
    };
    return { to, attributes };
  });
};

// will process the main array of paths, remember that paths property is an array of arrays
export const implementPasswordSourceLogic = (paths) => {
  // if given paths are undefined, pass null to next function to avoid show empty column
  if (!paths || !paths.length || !Array.isArray(paths)) return [addPasswordSourceFieldToPath(null)];

  const pathsResult = paths.map(addPasswordSourceFieldToPath);
  return pathsResult;
};

// function to add the passwordSource field to the items in CollectionModule
export const addPasswordSourceToCollection = (items) => {
  if (!items || !items.length) return [];

  const result = items.map(item => {
    const paths = implementPasswordSourceLogic(item.paths);
    return { ...item, paths };
  });
  return result;
};
